import tariffApi from '@/api/tariff';

export default {
  namespaced: true,
  state: () => ({
    items: [],
  }),
  getters: {
    itemsToShow(state) {
      return state.items
        .map((t) => ({
          ...t,
          pricePerMonth: t.pricePerMonth / 100,
          pricePerDay: t.pricePerDay / 100,
          maxStorage: Math.round(t.maxStorage/1024/1024/1024 * 1000) / 1000, // eslint-disable-line
        }));
    },
    itemsToShowFiltered(state, getters) {
      return getters.itemsToShow.filter((t) => !t.isPrivate);
    },
  },
  mutations: {
    setItems(state, payload) { state.items = payload; },
  },
  actions: {
    fetchItems({ state, commit }) {
      if (state.items.length) return;

      tariffApi.fetchList({}, true)
        .then((r) => { commit('setItems', r.items); });
    },
  },
};
